export default __webpack_public_path__ + "static/media/Home-eastern.9b495b10.png";